let API_URL, BASE_URL, REACT_APP_HOMEPAGE_URL, PREFIX;

const getTenantFromURL = () => {
  const url = window.location.hostname;
  const tenantId = url.split('.')[0];
  return url;
};

const currentURL = getTenantFromURL();

const isReactDevHost =
  currentURL === 'localhost' ||
  currentURL === '127.0.0.1' ||
  currentURL === '[::1]';

if (isReactDevHost) {
//API_URL = 'https://ebusso.siaresort.com/api';
API_URL = 'https://api.ebusso.com';
// API_URL = 'http://192.168.0.30/ebussopromo/';
    //  API_URL = 'http://localhost/ebusso_react_api/ebussopromo';
 //API_URL = 'http://localhost/ebussopromo/';
 // API_URL = 'http://localhost:8080/ebussopromo';
 BASE_URL = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';
  REACT_APP_HOMEPAGE_URL = 'http://localhost:3000';
    PREFIX = 'eve';
 // API_URL = 'https://promo.ramatechno.com/api';
} else if (currentURL === 'dev.ebusso.in') {
  API_URL = 'https://ebusso.in';
  BASE_URL = 'https://dev.ebusso.in';
  REACT_APP_HOMEPAGE_URL = 'https://dev.ebusso.in';
  PREFIX = 'tsc';
}  else if (currentURL === 'sales.tschilledfoods.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://sales.tschilledfoods.com';
  REACT_APP_HOMEPAGE_URL = 'https://sales.tschilledfoods.com';
  PREFIX = 'tsc';
} else if (currentURL === 'sales.everestcashandcarryuk.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://sales.everestcashandcarryuk.com';
  REACT_APP_HOMEPAGE_URL = 'https://sales.everestcashandcarryuk.com';
  PREFIX = 'eve';
} else if (currentURL === 'demo.ebusso.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://demo.ebusso.com';
  REACT_APP_HOMEPAGE_URL = 'https://demo.ebusso.com';
  PREFIX = 'ebu';
} else if (currentURL === 'manas.rameesystems.com') {
  API_URL = 'https://manas.rameesystems.com/api';
  BASE_URL = 'https://manas.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://manas.rameesystems.com';
  PREFIX = 'sdm';
} else if (currentURL === 'rhv.rameesystems.com') {
  API_URL = 'https://apimanas.rameegroup.co.in/api/';
  BASE_URL = 'https://rhv.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://rhv.rameesystems.com';
  PREFIX = 'rhv';
} else if (currentURL === 'sales.rightpriceltd.co.uk') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://sales.rightpriceltd.co.uk';
  REACT_APP_HOMEPAGE_URL = 'https://sales.rightpriceltd.co.uk';
  PREFIX = 'rhp';
} else if (currentURL === 'promo.ramatechno.com') {
  API_URL = 'https://promo.ramatechno.com/api';
  BASE_URL = 'https://promo.ramatechno.com';
  REACT_APP_HOMEPAGE_URL = 'https://promo.ramatechno.com';
  PREFIX = 'rhp';
} else if (currentURL === 'brit.rameesystems.com') {
  API_URL = 'https://brit.rameesystems.com/api';
  BASE_URL = 'https://brit.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://brit.rameesystems.com';
  PREFIX = 'bri';
}else if (currentURL === 'atrium.rameesystems.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://atrium.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://atrium.rameesystems.com';
  PREFIX = 'atr';
}else if (currentURL === 'gita.rameesystems.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://gita.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://gita.rameesystems.com';
  PREFIX = 'git';
}
else if (currentURL === 'ebusso.siaresort.com')
{
  API_URL = 'https://ebusso.siaresort.com/api';
  BASE_URL = 'https://ebusso.siaresort.com';
  REACT_APP_HOMEPAGE_URL = 'https://ebusso.siaresort.com';
  PREFIX = 'rhp';
  
}

// const PRODUCTS_LIST_PATH =
//   (typeof process !== "undefined" && process.env.REACT_APP_PRODUCTS_LIST_PATH) ||
//   " ";

// Used by ePOS product list fetch:
//   fetch(`${Config.API_URL}/${Config.PRODUCTS_LIST_PATH}`, { method: "POST", ... })
// So this must remain an endpoint path segment (not a base URL).
const PRODUCTS_LIST_PATH =
  (typeof process !== 'undefined' && process.env.REACT_APP_PRODUCTS_LIST_PATH) ||
  'get_products_list_band_wise';

const retainsCartDiscountFocus = ['ebu', 'eve', 'tsc', 'rhp'].includes(PREFIX);

export {
  API_URL,
  // BASE_URL,
  REACT_APP_HOMEPAGE_URL,
  PREFIX,
  PRODUCTS_LIST_PATH,
  retainsCartDiscountFocus,
};

// Static invoice pages under /public cannot import this module, so publish the
// resolved API base for them to read.
if (typeof window !== 'undefined' && API_URL) {
  try {
    window.localStorage.setItem('invoice_api_url', API_URL);
  } catch (e) {
    /* storage unavailable */
  }
}

const Config = {
  API_URL: API_URL,
  BASE_URL: BASE_URL,
  LOG_OUT: BASE_URL,
  PREFIX: PREFIX,
  PRODUCTS_LIST_PATH: PRODUCTS_LIST_PATH,
};

export default Config;


